import React, { FunctionComponent } from 'react';

export const Footer: FunctionComponent = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          © {year}{' '}
          <a href="https://www.account-able.io/terms-of-service" target="_blank" rel="noopener noreferrer">
            Terms of Service
          </a>
          {' & '}
          <a href="https://www.account-able.io/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
        </p>
      </div>
    </footer>
  );
};
